module.exports = __webpack_public_path__ + "img/Maelenn.9442dfb0.jpeg";